import { render, staticRenderFns } from "./EditTagDialog.vue?vue&type=template&id=574187df"
import script from "./EditTagDialog.vue?vue&type=script&lang=js"
export * from "./EditTagDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports